(function () {
  function getMarket() {
    var locale   = (window.Shopify && Shopify.locale)            ? Shopify.locale           : (document.documentElement.lang || 'en');
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : 'EUR';
    if (locale === 'et' || locale.indexOf('et-') === 0) return 'baltics';
    if (currency === 'USD') return 'us';
    return 'eu';
  }

  function run() {
    var market = getMarket();
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.attributes && cart.attributes.market === market) return;
        fetch('/cart/update.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ attributes: { market: market } })
        }).catch(function () {});
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();